import { MutableRefObject, useEffect, useState } from "react";
import { GetRef, InputRef, Select } from "antd";

type SelectRef = GetRef<typeof Select>;

const useFocus = (
  ref: MutableRefObject<null | InputRef | SelectRef>,
  isOpen: boolean,
  openOnInit: boolean = false,
) => {
  const [open, setOpen] = useState(openOnInit);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (isOpen) {
      ref.current.focus();
    } else {
      ref.current.blur();
    }
  }, [isOpen, ref]);

  const handleBlur = () => {
    setOpen(false);
  };

  const handleFocus = () => {
    setOpen(true);
  };

  return { open, handleBlur, handleFocus, setOpen };
};

export default useFocus;
